import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punerailwaystationcabservice() {



  const cardData = {
"keyword": "Pune Railway Station Cab Service",

"headingDescription":
  "Shivai Travels offers reliable and convenient Pune Railway Station Cab Service for passengers arriving or departing from Pune Junction. Whether you need a quick pickup, drop-off, or pre-booked ride, our service ensures timely arrivals, comfortable travel, and hassle-free luggage assistance. With professional drivers, clean air-conditioned vehicles, and transparent pricing with no hidden charges, we provide a smooth travel experience for solo travelers, families, and business passengers. Our fleet includes sedans, SUVs, and premium cars available 24/7 for early morning and late-night train schedules. Shivai Travels ensures safe, punctual, and affordable transportation from Pune Railway Station to any destination across the city or outstation routes.",

"topPlaces": [
  {
    "title": "Pune Railway Station Pickup Cab",
    "description": "Pune Railway Station cab service provides quick pickup for arriving passengers, ensuring easy connectivity to hotels, homes, and business locations across the city."
  },
  {
    "title": "Pune Railway Station Drop Taxi",
    "description": "Reliable drop cab service to Pune Railway Station helps travelers reach their trains on time with punctual, stress-free, and comfortable rides from any part of the city."
  },
  {
    "title": "24/7 Railway Station Cab Pune",
    "description": "Round-the-clock cab service at Pune Railway Station ensures availability for early morning arrivals and late-night departures with safe and dependable transportation."
  },
  {
    "title": "Affordable Station Taxi Pune",
    "description": "Budget-friendly Pune Railway Station cab service offers economical travel options for passengers looking for quick and reliable city transfers."
  },
  {
    "title": "Pune Station to City Cab Service",
    "description": "Taxi service from Pune Railway Station to major city areas like Shivaji Nagar, Kothrud, Hinjewadi, and Viman Nagar ensures smooth last-mile connectivity."
  },
  {
    "title": "Outstation Cab from Pune Railway Station",
    "description": "Outstation cab service from Pune Railway Station connects travelers directly to destinations like Mumbai, Nashik, Shirdi, and Mahabaleshwar with comfortable long-distance rides."
  },
  {
    "title": "Family Cab Service at Pune Station",
    "description": "Spacious vehicles like Innova, Ertiga, and SUVs are available at Pune Railway Station for family and group travel with safe and comfortable rides."
  },
  {
    "title": "Corporate Railway Station Pickup Pune",
    "description": "Professional cab service at Pune Railway Station is ideal for business travelers needing punctual pickups and drops with reliable transportation support."
  },
  {
    "title": "Prepaid Pune Railway Station Taxi",
    "description": "Prepaid cab options at Pune Railway Station ensure transparent fares, no hidden charges, and hassle-free travel experience for arriving passengers."
  },
  {
    "title": "Fast Cab Booking Pune Station",
    "description": "Instant cab booking at Pune Railway Station allows passengers to get quick rides on arrival with minimal waiting time and easy access to transportation."
  }
],



services: [
  {
    name: "Pune Railway Station Cab",
    description: "Pune railway station cab service provides reliable transportation for passengers traveling to and from Pune Railway Station. Comfortable vehicles with experienced drivers ensure smooth city and outstation travel for tourists, families, and business travelers. Pickup services are available from railway station platforms, homes, offices, hotels, and airport terminals across Pune. Vehicles include sedans, SUVs, Innova Crysta, Ertiga, and premium taxis suitable for different travel requirements. Flexible booking options allow convenient one-way and round-trip cab reservations."
  },
  {
    name: "Cab Near Pune Railway Station",
    description: "Cab near Pune railway station service offers convenient transportation for passengers looking for immediate taxi availability around Pune Junction and nearby areas. Comfortable vehicles provide smooth city travel and highway journeys suitable for local and outstation trips. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available from railway stations, hotels, offices, homes, and nearby locations across Pune. Flexible booking options allow quick and hassle-free cab reservations."
  },
  {
    name: "Taxi at Pune Station",
    description: "Taxi at Pune station service provides dependable transportation for passengers arriving or departing from Pune Railway Station. Vehicles ensure comfortable seating and reliable travel experience suitable for airport transfers, local travel, and outstation journeys. Professional chauffeurs ensure safe driving and timely pickup services throughout Pune and nearby destinations. Pickup services are available from station entrances, hotels, homes, offices, and airports. Flexible booking options allow convenient station taxi reservations."
  },
  {
    name: "Railway Pickup Drop Pune",
    description: "Railway pickup drop Pune service offers reliable transportation between Pune Railway Station and various city or outstation destinations. Comfortable vehicles provide smooth travel experience with sufficient luggage space suitable for train passengers. Professional drivers ensure punctual pickup and safe transportation services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient railway pickup and drop reservations."
  },
  {
    name: "Cab from Pune Railway Station",
    description: "Cab from Pune railway station service provides dependable transportation for passengers traveling from Pune Junction to local and outstation destinations. Comfortable vehicles ensure smooth city and highway travel suitable for families, tourists, and business travelers. Professional drivers ensure safe driving and timely pickup services from railway station locations. Pickup services are available for homes, hotels, offices, airports, and nearby destinations across Pune. Flexible booking options allow convenient station cab reservations."
  },
  {
    name: "Pune Station Taxi Service",
    description: "Pune station taxi service offers reliable transportation for passengers traveling to and from Pune Railway Station with comfortable vehicles and experienced chauffeurs. Vehicles provide spacious seating and smooth travel experience suitable for local and outstation journeys. Professional drivers ensure punctual pickup and safe transportation services throughout Pune. Pickup services are available from railway stations, homes, offices, hotels, and airports. Flexible booking options allow convenient station taxi reservations."
  },
  {
    name: "Affordable Station Cab Pune",
    description: "Affordable station cab Pune service provides budget-friendly transportation for passengers traveling from Pune Railway Station to city and outstation destinations. Comfortable vehicles ensure reliable travel while maintaining economical pricing for passengers. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from station areas, homes, hotels, offices, and airports across Pune. Flexible booking options allow convenient and affordable station cab reservations."
  },
  {
    name: "24 Hour Station Cab Pune",
    description: "24 hour station cab Pune service provides round-the-clock transportation for passengers arriving or departing from Pune Railway Station at any time. Comfortable vehicles ensure reliable city and highway travel with professional drivers maintaining punctual pickup schedules. Pickup services are available from railway stations, homes, hotels, offices, and airport terminals across Pune. Ideal for late-night train arrivals, early morning departures, and emergency travel needs. Flexible booking options allow convenient station cab reservations anytime."
  },
  {
    name: "Local Cab Near Station Pune",
    description: "Local cab near station Pune service offers convenient transportation for passengers traveling within Pune city from railway station locations. Comfortable vehicles ensure smooth city travel suitable for office commutes, shopping trips, tourism, and hotel transfers. Professional drivers ensure safe driving and timely pickup services throughout Pune. Pickup services are available from railway stations, homes, offices, hotels, and nearby destinations. Flexible booking options allow easy local cab reservations."
  },
  {
    name: "Station Transfer Taxi Pune",
    description: "Station transfer taxi Pune service provides reliable transportation between Pune Railway Station and airports, hotels, offices, and residential locations. Comfortable vehicles ensure smooth transfer experience with sufficient luggage space suitable for train travelers. Professional chauffeurs ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from station platforms, hotels, offices, homes, and airport terminals across Pune. Flexible booking options allow convenient station transfer reservations."
  },
  {
    name: "Best Cab Pune Railway Station",
    description: "Best cab Pune railway station service offers premium transportation for passengers looking for reliable and comfortable travel from Pune Junction. Vehicles provide smooth city and highway travel suitable for airport transfers, tourism, and business trips. Professional drivers ensure punctual pickup and safe transportation services throughout the journey. Pickup services are available from railway stations, homes, offices, hotels, and airports across Pune. Flexible booking options allow convenient station cab reservations."
  },
  {
    name: "Budget Station Taxi Pune",
    description: "Budget station taxi Pune service provides economical transportation for passengers traveling from Pune Railway Station to nearby and outstation destinations. Comfortable vehicles ensure reliable travel while maintaining affordable pricing for local and highway journeys. Professional drivers ensure safe driving and timely pickup services throughout Pune. Pickup services are available from railway stations, homes, offices, hotels, and airports. Flexible booking options allow convenient budget taxi reservations."
  },
  {
    name: "Instant Cab Railway Station Pune",
    description: "Instant cab railway station Pune service offers quick transportation for passengers requiring immediate taxi availability at Pune Railway Station. Comfortable vehicles provide smooth city and outstation travel suitable for airport transfers, business travel, and family trips. Professional drivers ensure fast pickup and safe driving services throughout the journey. Pickup services are available from railway stations, homes, hotels, offices, and airports across Pune. Flexible booking options allow convenient instant cab reservations."
  },
  {
    name: "Sedan Cab Station Pune",
    description: "Sedan cab station Pune service offers comfortable and economical transportation for passengers traveling from Pune Railway Station. Sedan vehicles provide smooth city travel and highway performance suitable for solo travelers, couples, and small families. Professional drivers ensure punctual pickup and safe transportation services throughout the journey. Pickup services are available from station areas, homes, hotels, offices, and airports across Pune. Flexible booking options allow convenient sedan cab reservations."
  },
  {
    name: "SUV Cab Pune Station",
    description: "SUV cab Pune station service provides spacious transportation for families and groups traveling from Pune Railway Station to local and outstation destinations. SUV vehicles offer comfortable seating, luggage capacity, and smooth highway travel suitable for long-distance journeys. Professional drivers ensure safe driving and punctual pickup services throughout Pune and nearby cities. Pickup services are available from station areas, homes, hotels, offices, and airports. Flexible booking options allow convenient SUV cab reservations."
  },
  {
    name: "Pune Station to Mumbai Cab Service",
    description: "Pune station to Mumbai cab service provides reliable transportation between Pune Railway Station and Mumbai with comfortable vehicles and experienced drivers. Vehicles are suitable for expressway travel ensuring smooth and safe journeys for passengers. Pickup services are available from Pune Junction, homes, hotels, offices, and airport terminals across Pune and Mumbai. Ideal for business travel, airport transfers, tourism, and family visits. Flexible booking options allow convenient one-way and round-trip cab reservations."
  }
],

tableData: [
  ["Pune Railway Station Cab", "Cab Near Pune Railway Station"],
  ["Taxi at Pune Station", "Railway Pickup Drop Pune"],
  ["Cab from Pune Railway Station", "Pune Station Taxi Service"],
  ["Affordable Station Cab Pune", "24 Hour Station Cab Pune"],
  ["Local Cab Near Station Pune", "Station Transfer Taxi Pune"],
  ["Best Cab Pune Railway Station", "Budget Station Taxi Pune"],
  ["Instant Cab Railway Station Pune", "Sedan Cab Station Pune"],
  ["SUV Cab Pune Station", "Pune Station to Mumbai Cab Service"]
],



 whychoose: [
      {
        WhyChooseheading: "Reliable Pune Railway Station Cab Service",
        WhyChoosedescription: "Shivai Travels provides reliable Pune Railway Station cab service for timely pickup and drop transportation. Our drivers ensure smooth travel for passengers arriving at or departing from Pune Junction Railway Station."
      },
      {
        WhyChooseheading: "Affordable Railway Station Taxi Pricing",
        WhyChoosedescription: "Shivai Travels offers affordable Pune Railway Station cab service with transparent pricing and no hidden charges. Customers receive clear fare details before booking confirmation."
      },
      {
        WhyChooseheading: "24/7 Railway Station Cab Availability",
        WhyChoosedescription: "Our Pune Railway Station cab service operates 24 hours a day for early morning train departures, late-night arrivals, emergency travel, and business transportation requirements."
      },
      {
        WhyChooseheading: "Comfortable & Clean AC Taxis",
        WhyChoosedescription: "All taxis provided by Shivai Travels are fully air-conditioned, sanitized, and regularly maintained to provide safe and comfortable travel experiences for railway passengers."
      },
      {
        WhyChooseheading: "One Way & Round Trip Travel Options",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including railway station pickup, drop service, one-way taxi bookings, round trips, and customized Pune travel plans."
      },
      {
        WhyChooseheading: "Wide Range of Taxi Vehicles",
        WhyChoosedescription: "Customers can choose from sedan taxis, Ertiga, Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for individuals, families, and group travelers."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides pickup and drop services from homes, hotels, offices, Pune Airport, and all major Pune locations including Baner, Wakad, Kharadi, Hadapsar, and Hinjewadi."
      },
      {
        WhyChooseheading: "Professional Drivers for Railway Transfers",
        WhyChoosedescription: "Our experienced drivers provide punctual railway station transfers, luggage assistance, smooth city navigation, and professional customer service for every journey."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune Railway Station cab service?", answer: "Pune Railway Station cab service provides pickup and drop transportation for passengers traveling to and from Pune Junction Railway Station." },
    { question: "Is Pune Railway Station cab service available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 railway station taxi service in Pune." },
    { question: "Which vehicles are available for railway station cab booking?", answer: "Shivai Travels offers sedan taxis, Ertiga, Innova, Innova Crysta, and Tempo Travellers." },
    { question: "Can I book a one-way railway station taxi in Pune?", answer: "Yes, customers can book one-way railway station pickup or drop taxi services." },
    { question: "Do you provide pickup from Pune Junction Railway Station?", answer: "Yes, Shivai Travels provides both railway station pickup and drop services." },
    { question: "Are all railway station taxis air-conditioned?", answer: "Yes, all taxis are fully air-conditioned and maintained for passenger comfort." },
    { question: "Can I book Pune Railway Station cab service online?", answer: "Yes, customers can easily book Pune Railway Station cab service online or through phone booking." },
    { question: "Do you provide railway station taxis for family travel?", answer: "Yes, Shivai Travels provides comfortable taxis suitable for family and group travel." },
    { question: "Are railway station taxi fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent taxi pricing without hidden charges." },
    { question: "Is advance railway station cab booking available?", answer: "Yes, advance booking is available and recommended for railway station transfers." }
  ];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohan Deshmukh",
    feedback:
      "Shivai Travels provided a very convenient Pune Railway Station cab service with on-time pickup and smooth coordination for my train arrival transfer.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Patil",
    feedback:
      "The cab service from Pune Railway Station was hassle-free with a clean vehicle and a polite driver who helped with luggage and ensured a comfortable ride.",
    rating: 5
  }
];








































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Railway Station Cab Service",
  "image": "https://shivaitravels.com/assets/images/pune-station-cab.jpg",
  "description": "Book Pune railway station cab service for local and outstation travel. Shivai Travels offers affordable taxi pickup and drop services from Pune Junction with sedan, SUV, and AC cab options available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹499",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/pune-railway-station-cab-service"
  }
};







  return (
    <div>

<Helmet>
  <title>Pune Railway Station Cab Service | Pickup & Drop Taxi | +91 9689815477</title>

  <meta
    name="description"
    content="Book Pune railway station cab service for local and outstation travel. Affordable taxi pickup and drop services from Pune Junction with sedan, SUV, and AC cabs available 24x7."
  />

  <meta
    name="keywords"
    content="station taxi pune, taxi at pune station, railway pickup drop pune, cab from pune railway station, pune station taxi service, affordable station cab pune, 24 hour station cab pune, local cab near station pune, station transfer taxi pune, best cab pune railway station, budget station taxi pune, instant cab railway station pune, sedan cab station pune, suv cab pune station, Pune Railway Station Cab for Outstation, Outstation Cab from Pune Railway Station, Pune Station Taxi Service for Outstation, Railway Station Outstation Cab Pune, Pune Junction Outstation Cab Booking, Pune Railway Station Taxi Booking"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/10.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punerailwaystationcabservice;